import { GroupUserRole } from 'multirpc-sdk';

import { AccountPermission, permissionsMap } from '../constants';

export interface CheckAccountPermissionParams {
  permission: AccountPermission;
  role: GroupUserRole;
}

export const checkAccountPermission = ({
  permission,
  role,
}: CheckAccountPermissionParams) => permissionsMap[role].includes(permission);
